import React from 'react'
import { addDays } from 'date-fns'
import { formValues } from 'redux-form'
import { DateInput } from '../../../../components/FormBuilder'

const DateInputWithInitialValue = ({ dateFrom, ...rest }) => (
  <DateInput.ReduxField
    {...rest}
    withEmptyOnStart={true}
    startDate={addDays(dateFrom, 1)}
  />
)

export default formValues<any>('dateFrom')(DateInputWithInitialValue)
